import { Close } from '@mui/icons-material';
import {
  Box,
  Dialog,
  DialogContent,
  IconButton,
  ImageList,
  ImageListItem,
  Paper,
  Typography,
  Zoom,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

// const mockImages = [
//   {
//     date: '2022-07-26T18:51:41',
//     url: 'https://mobile-vtr.s3.amazonaws.com/100/1234/5b7d567c5b10473389c408d2/0dd6d920-a02f-4ef7-92ff-833b050ae5a8.jpg?AWSAccessKeyId=AKIATK764DKSTFBEHKX6&Expires=1659365275&Signature=3g6wKu1OT%2FP9f0qW3qjQZxigFTM%3D',
//   },
//   {
//     date: '2022-07-26T18:51:41',
//     url: 'https://mobile-vtr.s3.amazonaws.com/100/1234/5e2f6d11d62319599277bedc/61d10caf-543d-4c7a-b346-9ac1a425e938.jpg?AWSAccessKeyId=AKIATK764DKSTFBEHKX6&Expires=1659365275&Signature=2N4MzQFFXN2RfoY%2BTmj%2FNjsCsps%3D',
//   },
//   {
//     date: '2022-07-26T18:51:41',
//     url: 'https://mobile-vtr.s3.amazonaws.com/100/1234/5b7d567c5b10473389c408d2/0dd6d920-a02f-4ef7-92ff-833b050ae5a8.jpg?AWSAccessKeyId=AKIATK764DKSTFBEHKX6&Expires=1659365275&Signature=3g6wKu1OT%2FP9f0qW3qjQZxigFTM%3D',
//   },
//   {
//     date: '2022-07-26T18:51:41',
//     url: 'https://mobile-vtr.s3.amazonaws.com/100/1234/5e2f6d11d62319599277bedc/61d10caf-543d-4c7a-b346-9ac1a425e938.jpg?AWSAccessKeyId=AKIATK764DKSTFBEHKX6&Expires=1659365275&Signature=2N4MzQFFXN2RfoY%2BTmj%2FNjsCsps%3D',
//   },
//   {
//     date: '2022-07-26T18:51:41',
//     url: 'https://mobile-vtr.s3.amazonaws.com/100/1234/5b7d567c5b10473389c408d2/0dd6d920-a02f-4ef7-92ff-833b050ae5a8.jpg?AWSAccessKeyId=AKIATK764DKSTFBEHKX6&Expires=1659365275&Signature=3g6wKu1OT%2FP9f0qW3qjQZxigFTM%3D',
//   },
//   {
//     date: '2022-07-26T18:51:41',
//     url: 'https://mobile-vtr.s3.amazonaws.com/100/1234/5e2f6d11d62319599277bedc/61d10caf-543d-4c7a-b346-9ac1a425e938.jpg?AWSAccessKeyId=AKIATK764DKSTFBEHKX6&Expires=1659365275&Signature=2N4MzQFFXN2RfoY%2BTmj%2FNjsCsps%3D',
//   },
//   {
//     date: '2022-07-26T18:51:41',
//     url: 'https://mobile-vtr.s3.amazonaws.com/100/1234/5b7d567c5b10473389c408d2/0dd6d920-a02f-4ef7-92ff-833b050ae5a8.jpg?AWSAccessKeyId=AKIATK764DKSTFBEHKX6&Expires=1659365275&Signature=3g6wKu1OT%2FP9f0qW3qjQZxigFTM%3D',
//   },
//   {
//     date: '2022-07-26T18:51:41',
//     url: 'https://mobile-vtr.s3.amazonaws.com/100/1234/5e2f6d11d62319599277bedc/61d10caf-543d-4c7a-b346-9ac1a425e938.jpg?AWSAccessKeyId=AKIATK764DKSTFBEHKX6&Expires=1659365275&Signature=2N4MzQFFXN2RfoY%2BTmj%2FNjsCsps%3D',
//   },
//   {
//     date: '2022-07-26T18:51:41',
//     url: 'https://mobile-vtr.s3.amazonaws.com/100/1234/5b7d567c5b10473389c408d2/0dd6d920-a02f-4ef7-92ff-833b050ae5a8.jpg?AWSAccessKeyId=AKIATK764DKSTFBEHKX6&Expires=1659365275&Signature=3g6wKu1OT%2FP9f0qW3qjQZxigFTM%3D',
//   },
//   {
//     date: '2022-07-26T18:51:41',
//     url: 'https://mobile-vtr.s3.amazonaws.com/100/1234/5e2f6d11d62319599277bedc/61d10caf-543d-4c7a-b346-9ac1a425e938.jpg?AWSAccessKeyId=AKIATK764DKSTFBEHKX6&Expires=1659365275&Signature=2N4MzQFFXN2RfoY%2BTmj%2FNjsCsps%3D',
//   },
//   {
//     date: '2022-07-26T18:51:41',
//     url: 'https://mobile-vtr.s3.amazonaws.com/100/1234/5b7d567c5b10473389c408d2/0dd6d920-a02f-4ef7-92ff-833b050ae5a8.jpg?AWSAccessKeyId=AKIATK764DKSTFBEHKX6&Expires=1659365275&Signature=3g6wKu1OT%2FP9f0qW3qjQZxigFTM%3D',
//   },
//   {
//     date: '2022-07-26T18:51:41',
//     url: 'https://mobile-vtr.s3.amazonaws.com/100/1234/5e2f6d11d62319599277bedc/61d10caf-543d-4c7a-b346-9ac1a425e938.jpg?AWSAccessKeyId=AKIATK764DKSTFBEHKX6&Expires=1659365275&Signature=2N4MzQFFXN2RfoY%2BTmj%2FNjsCsps%3D',
//   },
//   {
//     date: '2022-07-26T18:51:41',
//     url: 'https://mobile-vtr.s3.amazonaws.com/100/1234/5b7d567c5b10473389c408d2/0dd6d920-a02f-4ef7-92ff-833b050ae5a8.jpg?AWSAccessKeyId=AKIATK764DKSTFBEHKX6&Expires=1659365275&Signature=3g6wKu1OT%2FP9f0qW3qjQZxigFTM%3D',
//   },
//   {
//     date: '2022-07-26T18:51:41',
//     url: 'https://mobile-vtr.s3.amazonaws.com/100/1234/5e2f6d11d62319599277bedc/61d10caf-543d-4c7a-b346-9ac1a425e938.jpg?AWSAccessKeyId=AKIATK764DKSTFBEHKX6&Expires=1659365275&Signature=2N4MzQFFXN2RfoY%2BTmj%2FNjsCsps%3D',
//   },
// ];

interface Image {
  date: string;
  url: string;
}

function ImagesBlock({ images }: { images: Image[] }) {
  const { t } = useTranslation('_common');
  const [srcSelected, setSrcSelected] = React.useState('');

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        flex: '1 1 auto',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Typography variant="h6">{t('images')}</Typography>
      <ImageList cols={3} rowHeight={200} sx={{ flex: '1 1 auto', maxHeight: 400 }}>
        {images.map((image) => (
          <ImageListItem
            key={image.url}
            onClick={() => setSrcSelected(image.url)}
            sx={{
              '	.MuiImageListItem-img': {
                height: '200px',
              },
              cursor: 'pointer',
            }}
          >
            <img src={image.url} srcSet={image.url} alt={image.date} loading="lazy" />
          </ImageListItem>
        ))}
      </ImageList>
      <ImageModal {...{ srcSelected, setSrcSelected }} />
    </Paper>
  );
}

function ImageModal({
  srcSelected,
  setSrcSelected,
}: {
  srcSelected: string;
  setSrcSelected: React.Dispatch<React.SetStateAction<string>>;
}) {
  return (
    <Dialog
      open={!!srcSelected}
      onClose={() => setSrcSelected('')}
      TransitionComponent={Zoom}
      scroll="paper"
    >
      <Box sx={{ p: 1, display: 'flex', justifyContent: 'flex-end' }}>
        <IconButton>
          <Close onClick={() => setSrcSelected('')} />
        </IconButton>
      </Box>
      <DialogContent sx={{ overflow: 'hidden', maxWidth: '100%', maxHeight: '100%' }}>
        <Box
          component="img"
          src={srcSelected}
          srcSet={srcSelected}
          alt="selected"
          loading="lazy"
          sx={{ objectFit: 'contain', maxWidth: '100%', maxHeight: '100%' }}
        />
      </DialogContent>
    </Dialog>
  );
}

export default ImagesBlock;
